/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CreateClassPlanningChecklistItemRequestViewModel } from "../types/CreateClassPlanningChecklistItemRequestViewModel.ts";

export const createClassPlanningChecklistItemRequestViewModelSchema = z.object({
  description: z.string().nullish(),
  isDone: z.optional(z.boolean()),
  value: z.number().nullish(),
  observation: z.string().nullish(),
}) as unknown as ToZod<CreateClassPlanningChecklistItemRequestViewModel>;
